import { chartColors } from '../../../Common/Charts/enums/chart-colors.enum';
import { UserAppPreferenceChartColors } from '../models/user-app-preferences-chart-colors.model';

export const defaultChartColorsPaMedia: UserAppPreferenceChartColors = {
    generalColors: {
        color1: chartColors.agprWlColor1,
        color2: chartColors.agprWlColor2,
        color3: chartColors.agprWlColor3,
        color4: chartColors.agprWlColor4,
        color5: chartColors.agprWlColor5,
        color6: chartColors.agprWlColor6,
        color7: chartColors.agprWlColor7,
        color8: chartColors.agprWlColor8,
        color9: chartColors.agprWlColor9,
        color10: chartColors.agprWlColor10,
    },
    mediaTypeColors: {
        onlineNews: chartColors.agprWlOnline,
        print: chartColors.agprWlPrint,
        pressRelease: chartColors.agprWlPressRelease,
        blogs: chartColors.agprWlBlog,
        TV: chartColors.agprWlTelevision,
        radio: chartColors.agprWlRadio,
        podcast: chartColors.agprWlPodcast,
        facebook: chartColors.agprWlFacebook,
        twitter: chartColors.agprWlX,
        reddit: chartColors.agprWlReddit,
        youtube: chartColors.agprWlYoutube,
        instagram: chartColors.agprWlInstagram,
        tiktok: chartColors.agprWlTiktok,
        snapchat: chartColors.agprWlSnapchat,
        threads: chartColors.agprWlThreads,
        linkedin: chartColors.agprWlLinkedIn,
        bluesky: chartColors.agprWlBluesky,
        wechat: chartColors.agprWlWechat,
        sinaWeibo: chartColors.agprWlSinaWeibo,
        twitch: chartColors.agprWlTwitch,
        pinterest: chartColors.agprWlPinterest,
        tumblr: chartColors.agprWlTumblr,
        telegram: chartColors.agprWlTelegram,
        whatsapp: chartColors.agprWlWhatsapp,
        vk: chartColors.agprWlVK,
        other: chartColors.agprWlOther,
        magazine: chartColors.agprWlMagazine
    },
    socialNetworkColors: {
        facebook: chartColors.agprWlFacebook,
        twitter: chartColors.agprWlX,
        reddit: chartColors.agprWlReddit,
        youtube: chartColors.agprWlYoutube,
        instagram: chartColors.agprWlInstagram,
        tiktok: chartColors.agprWlTiktok,
        linkedin: chartColors.agprWlLinkedIn,
        bluesky: chartColors.agprWlBluesky,
    },
    sentimentColors: {
        positive: chartColors.agprWlPositive,
        negative: chartColors.agprWlNegative,
        neutral: chartColors.agprWlNeutral,
        notAvailable: chartColors.agprWlNotAvailable,
    },
    gaugeColors: {
        color1: chartColors.agprWlPositive,
        color2: chartColors.agprWlNeutral,
        color3: chartColors.agprWlNegative
    },
    barColors: {
        barColor: chartColors.agprWlColor1,
        previousBarColor: chartColors.agprLighterMediumGrey
    },
    otherColors: {
        uptrendColor: chartColors.agprWlPositive,
        downtrendColor: chartColors.agprWlNegative,
        bigNumberColor: chartColors.agprText,
        textColor: chartColors.agprText,
        volume: chartColors.agprWlVolume,
        volumePrevious: chartColors.agprWlVolumePrevious,
        engagements: chartColors.agprWlEngagements,
        engagementPrevious: chartColors.agprWlEngagementsPrevious,
        impressions: chartColors.agprWlImpressions,
        impressionsPrevious: chartColors.agprWlImpressionsPrevious
    }
};
